import { AxiosPromise } from 'axios'
import { clientV2, clientV21 } from './base'
import { Response } from './types'
import qs from 'qs'
import { Currency } from '@/generated/gql/graphql'

export const clientInitiateCcOrder = (
  amount: string | number,
  bundle: number,
  date: string | Date,
  meal: string,
  items: unknown[],
  arrivalTime: string | Date,
  currency: Currency,
  orderCodes: { code: string; value: string }[],
): AxiosPromise<Response<{ authToken: string }>> =>
  clientV2.post('/initiateCcOrder', {
    amount,
    bundle,
    date,
    meal,
    items,
    arrivalTime,
    currency,
    orderCodes,
  })

export const ccPlaceOrder21 = async (
  date: string | Date,
  meal: string,
  items: unknown[],
  arrivalTime: string | Date,
  orderCodes: { code: string; value: string }[],
  language: string,
) =>
  clientV21.post(`/ccOrderItems?${qs.stringify({ language })}`, {
    payment: {},
    amount: 0,
    bundle: 0,
    date,
    meal,
    items,
    arrivalTime,
    orderCodes,
    respondAsObject: true,
  })

export const ccDashboardCancelOrder = async (id: number | string) =>
  clientV2.delete(`/dashboard/orders/${id}`)
